export const emptyArray: never[] = [];
